import { Link } from 'react-router-dom';

const areas = [
  {
    name: 'Worksop',
    slug: '/',
    desc: 'Our home base. We cover all of Worksop — from Kilton to Manton, Rhodesia to Worksop town centre.',
    postcodes: 'S80, S81',
    icon: 'ri-home-4-fill',
  },
  {
    name: 'Retford',
    slug: '/locations',
    desc: 'Full electrical services available throughout Retford, East Retford and the surrounding villages.',
    postcodes: 'DN22',
    icon: 'ri-building-fill',
  },
  {
    name: 'Carlton in Lindrick',
    slug: '/locations',
    desc: 'Local electrician serving Carlton in Lindrick and the Lindrick area with fast response times.',
    postcodes: 'S81',
    icon: 'ri-map-pin-2-fill',
  },
  {
    name: 'Shireoaks',
    slug: '/locations',
    desc: 'Reliable electrical services for Shireoaks homeowners — from planned work to full rewires.',
    postcodes: 'S81',
    icon: 'ri-map-pin-fill',
  },
];

export default function AreasCovered() {
  return (
    <section className="py-20 bg-cream font-body">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-gold-100 text-gold-600 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 border border-gold-200">
            Areas We Cover
          </span>
          <h2 className="font-heading font-extrabold text-navy-800 mb-4" style={{ fontSize: 'clamp(2rem, 4vw, 2.8rem)' }}>
            Covering Worksop &amp; Surrounding Areas
          </h2>
          <p className="text-navy-600/60 max-w-xl mx-auto leading-relaxed">
            Based in Worksop, we provide fast, reliable electrical services across North Nottinghamshire and South Yorkshire.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {areas.map((area) => (
            <div key={area.name} className="bg-white rounded-xl p-6 border border-gold-200/60 hover:border-gold-400 transition-all group">
              <div className="w-12 h-12 flex items-center justify-center bg-navy-800 rounded-lg mb-4 group-hover:bg-gold-400 transition-colors">
                <i className={`${area.icon} text-gold-400 group-hover:text-navy-800 text-xl transition-colors`}></i>
              </div>
              <h3 className="font-heading font-bold text-navy-800 text-lg mb-1">{area.name}</h3>
              <p className="text-gold-500 text-xs font-bold mb-3">Postcodes: {area.postcodes}</p>
              <p className="text-navy-600/60 text-sm leading-relaxed mb-4">{area.desc}</p>
              <Link
                to={area.slug}
                className="inline-flex items-center gap-1.5 text-gold-500 hover:text-gold-400 font-semibold text-sm transition-colors cursor-pointer"
              >
                More Info
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          ))}
        </div>

        {/* Map embed */}
        <div className="rounded-xl overflow-hidden border border-gold-200" style={{ height: '360px' }}>
          <iframe
            title="Worksop service area map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d76527.71!2d-1.15!3d53.30!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4879b73e1e6b86a9%3A0x5c15ad3b5df5e4d6!2sWorksop!5e0!3m2!1sen!2suk!4v1710000000000!5m2!1sen!2suk"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
}
